import React from "react";

export default function IconButton({ icon, onClick, active }) {
    return (
        <div className={`icon-button${active ? " active" : ""}`} onClick={onClick}>
            {icon}
        </div>
    );
}
